import _ax from "./_ax";

export function getVipData() {
  return _ax.get(`get-vip-data`);
}

export function upgradeLevel(data) {
  return _ax.post("update-vip", data);
}

export function getFMemberByDate() {
  return _ax.post("getFMemberByDate");
}
//getFMemberByYesterday
export function getFMemberByYesterday(pageSize, pageNumber, search = 'F1', filterBy = 'level') {
  if (search === null) {
    search = 'F1';
  }
  if (filterBy === null) {
    filterBy = 'level';
  }
  
  return _ax.post("getFMemberByYesterday", {pageSize, page:pageNumber, search, filterBy});
}
//getFMemberLast7Days
export function getFMemberLast7Days(pageSize, pageNumber, search = 'F1', filterBy = 'level') {
  if (search === null) {
    search = 'F1';
  }
  if (filterBy === null) {
    filterBy = 'level';
  }
  return _ax.post("getFMemberLast7Days", {pageSize, page:pageNumber, search, filterBy});
}
//getFMemberLast30Days
export function getFMemberLast30Days(pageSize, pageNumber, search = 'F1', filterBy = 'level') {
  if (search === null) {
    search = 'F1';
  }
  if (filterBy === null) {
    filterBy = 'level';
  }
  return _ax.post("getFMemberLast30Days", {pageSize, page:pageNumber, search, filterBy});
}
// get member info
export function getFmemberInfo(id) {
  return _ax.post("getFmemberInfo", {id});
}
